<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-08 17:15:24
 * @Description: file content
 -->
<template>
  <a-modal class="obit-modal-default customerDetails" title="用户详情" :confirm-loading="confirmLoading" :maskClosable="false" v-model:visible="open" @cancel="closeDialog"
    :footer="null" width="1280px">
    <a-descriptions title="基础信息" bordered>
      <a-descriptions-item label="登录账号" name="userName">{{formData.userName}}</a-descriptions-item>
      <a-descriptions-item label="用户姓名" name="nickName">{{formData.nickName}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="详情信息" bordered class="m-t-15" :column="2">
      <a-descriptions-item label="手机号码" name="phonenumber">{{formData.phonenumber}}</a-descriptions-item>
      <a-descriptions-item label="邮箱" name="email">{{formData.email}}</a-descriptions-item>
      <a-descriptions-item label="性别" name="sex">{{formData.sex}}</a-descriptions-item>
      <a-descriptions-item label="生日" name="birthday">{{formData.birthday}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="职责信息" bordered class="m-t-15" :column="2">
      <a-descriptions-item label="部门" name="dept">{{formData.dept.deptName||''}}</a-descriptions-item>
      <a-descriptions-item label="所属角色" name="userRoleNameStrings">{{formData.userRoleNameStrings}}</a-descriptions-item>
      <a-descriptions-item label="岗位" name="postName">{{formData.postName}}</a-descriptions-item>
      <a-descriptions-item label="编号" name="userNo">{{formData.userNo}}</a-descriptions-item>
      <a-descriptions-item label="工号" name="jobNo">{{formData.jobNo}}</a-descriptions-item>
      <a-descriptions-item label="地址" name="userAddress">{{formData.userAddress}}</a-descriptions-item>
      <a-descriptions-item label="备注" name="remark">{{formData.remark}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="所属区域" bordered class="m-t-15">
      <a-descriptions-item label="区域" name="areaNames">{{formData.areaNames}}</a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>
<script>
import { getCurrentInstance, inject, onMounted, reactive, toRefs } from 'vue'
import { util } from 'obit-wui'


export default {
  // inheritAttrs: false,
  props: {
    open: {
      type: Boolean
    },
    dataInfo: {
      type: Object
    },
  },
  setup (props, context) {
    let http = inject('http')
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      formData: {},
      confirmLoading: false,
    })
    let _methods = {
      closeDialog () {
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
    }
    onMounted(() => {
      let data = util.util.cloneObj(props.dataInfo)
      data.sex = proxy.$fmt('sys_user_sex', data.sex)
      data.postName = proxy.$fmt('sys_user_post', data.postName)
      _data.formData = data
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
.customerDetails {
  .ant-modal-body {
    padding: 40px;
  }
}
</style>